<template>
  <div>
    <v-btn-toggle
      mandatory
      style="width: 100%"
      v-if="$vuetify.breakpoint.smAndUp"
      v-model="toggleValue"
    >
      <v-btn
        large
        v-for="(item, i) in items"
        :key="`${item.status}--${i}`"
        @click="setSelectStatus(item.status)"
        style="flex: 1"
        ref="item"
        :style="{
          'text-transform': textTransformNone ? 'none' : 'uppercase',
        }"
      >
        <v-icon left :color="handleColorStatus(item.status)" size="10"
          >mdi-circle</v-icon
        >
        {{ item.text }}
      </v-btn>
    </v-btn-toggle>
    <v-select
      v-else
      v-model="select"
      :items="items"
      @change="setSelectStatus"
      item-text="text"
      item-value="status"
      :label="$t('status')"
      prepend-icon="mdi-list-status"
      dense
      filled
      hide-details
      solo-inverted
    ></v-select>
  </div>
</template>
<script>
export default {
  name: "components-common-filters-select-status",
  data: () => ({
    select: {},
    toggleValue: 0,
    textTransformNone: false,
  }),
  computed: {
    items() {
      if (this.$route.name == "AdministratorUsersAgentsList") {
        return [
          { text: this.$t("active"), status: 1 },
          { text: this.$t("pending"), status: 2 },
          { text: this.$t("didSuspended"), status: 0 },
          { text: this.$t("inactives"), status: 3 },
          { text: this.$t("blocked"), status: 6 },
        ];
      } else if (
        this.$route.name === "AdministratorListCollaborator" ||
        this.$route.name === "AdministratorCreateCollaborator" ||
        this.$route.name === "AdministratorEditCollaborator"
      ) {
        return [
          { text: this.$t("active"), status: 1 },
          { text: this.$t("didSuspended"), status: 0 },
          { text: this.$t("blocked"), status: 6 },
        ];
      } else if (
        this.$route.name === "ListPromotionOnline" ||
        this.$route.name == "CollaboratorListPromotionOnline" ||
        this.$route.name == "CollaboratorListAdhesions" ||
        this.$route.name === "ListAdhesions" ||
        this.$route.name === "ExportPromotionTokens" ||
        this.$route.name === "AdministratorFreespins" ||
        this.$route.name === "CollaboratorFreespins"
      ) {
        return [
          { text: this.$t("inForce"), status: 1 },
          { text: this.$t("notInForce"), status: 0 },
        ];
      } else if (
        this.$route.name === "AdministratorAffiliatesCampaings"
        || this.$route.name === "CollaboratorAffiliatesCampaings"
      ) {
        return [
          { text: this.$t("activeCampaigns"), status: 1 },
          { text: this.$t("desactiveCampaigns"), status: 0 },
        ];
      } else {
        return [
          { text: this.$t("active"), status: 1 },
          { text: this.$t("pending"), status: 2 },
          { text: this.$t("didSuspended"), status: 0 },
          { text: this.$t("blocked"), status: 6 },
        ];
      }
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
  },

  created() {
    // Tratamento para Adm > Users > Agents > List
    // this.handleInactives();
    if (
      this.$route.name === "ListPromotionOnline" ||
      this.$route.name == "CollaboratorListPromotionOnline"
    ) {
      this.select = 1;
    }

    if (
      this.$route.name === "AdministratorAffiliatesCampaings"
      || this.$route.name === "CollaboratorAffiliatesCampaings"
    ) {
      this.select = 1;
      this.textTransformNone = true;
    }
  },
  mounted() {
    // Tratamento para Adm > Users > Agents > List
    // this.handleInactives();
    if (
      this.$route.name === "ListPromotionOnline" ||
      this.$route.name == "CollaboratorListPromotionOnline"
    ) {
      this.select = 1;
    }
  },
  watch: {
    toggleValue() {
      this.items.map((item, index) => {
        if (item.status == this.status) {
          this.toggleValue = index;
        }
      });
    },
    $route(newVal, oldVal) {
      if (oldVal.name == "AdministratorUsersAgentsList" && this.status == 3) {
        this.setSelectStatus(1);
      }
      if (this.$route.name === "AdministratorListCollaborator") {
        this.setSelectStatus(1);
      }

      if (
        this.$route.name === "AdministratorAffiliatesCampaings"
        || this.$route.name === "CollaboratorAffiliatesCampaings"
      ) {
        this.select = 1;
        this.textTransformNone = true;
      }
    },
    status(val) {
      if (val == 1) {
        if (
          this.$route.name == "ListPromotionOnline" ||
          this.$route.name == "CollaboratorListPromotionOnline"
        ) {
          this.toggleValue = 1;
          this.select = 1;
        }

        if (
          this.$route.name === "AdministratorFreespins" ||
          this.$route.name === "CollaboratorFreespins"
        ) {
          this.toggleValue = 1;
          this.select = 1;
          this.$refs.item[0].$el.click();
        }
      }
    },
  },
  methods: {
    setSelectStatus(status) {
      this.items.map((item, index) => {
        if (item.status == status) {
          this.toggleValue = index;
        }
      });

      // Condicional Exclusiva para Adm > Usuários > Agentes Inativos!!!
      if (this.$route.name === "AdministratorUsersAgentsList") {
        var bool = status === 3;
        // this.$store.commit("Range", bool);
        // this.$store.commit("QuantityBet", bool);
        this.$store.commit("AutocompleteRoutes", bool);
        this.$store.commit("AutocompleteAgents", !bool);
      }

      // Set Store
      this.$store.commit("setSelectStatus", status);
    },
    // handleInactives() {
    //   const routeName = this.$route.name;
    //   const supportedPages = ["AdministratorUsersAgentsList"];
    //   if (supportedPages.includes(routeName)) {
    //     this.items.push({ text: "Inativos", status: 3 });
    //   } else if (this.items.some((item) => item.status === 3)) {
    //     this.items.pop();
    //   }
    // },
    handleColorStatus(status) {
      if (
        status == 0 &&
        (this.$route.name === "ListPromotionOnline" ||
          this.$route.name === "ListAdhesions" ||
          this.$route.name == "CollaboratorListAdhesions" ||
          this.$route.name == "CollaboratorListPromotionOnline" ||
          this.$route.name === "AdministratorFreespins" ||
          this.$route.name === "CollaboratorFreespins" ||
          this.$route.name === "AdministratorAffiliatesCampaings" ||
          this.$route.name === "CollaboratorAffiliatesCampaings"
        )
      )
        return "blue-grey";
      if (status == 0) return "red";
      if (status == 1) return "green";
      if (status == 2) return "orange";
      if (status == 3) return "purple";
      if (status == 6) return "grey";
    },
  },
};
</script>
